module.exports = __webpack_public_path__ + "img/background.29f39938.jpg";